import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { GoogleLogo, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const Register = () => {
  const { register, loginGoogle } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [telefono, setTelefono] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("La contraseña debe tener al menos 6 caracteres"); return; }
    setLoading(true);
    try {
      const profile = await register(email, password, { telefono });
      if (profile) { toast.success("¡Cuenta creada!"); navigate("/dashboard"); }
      else { toast.success("Revisa tu email para confirmar la cuenta"); navigate("/login"); }
    } catch (err) {
      if (err?.needsEmailConfirmation) {
        toast.success("Cuenta creada — revisa tu email para confirmarla");
        navigate("/login");
      } else if (err?.code === "rate_limit") {
        toast.error(err.message);
      } else {
        toast.error(err?.message || "No se pudo crear la cuenta");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = async () => {
    try { await loginGoogle(); }
    catch (err) { toast.error(err?.message || "Error con Google"); }
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2" data-testid="register-page">
      <div className="flex items-center justify-center p-8 md:p-16 order-2 lg:order-1 bg-paper">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
          <span className="text-[11px] uppercase tracking-[0.3em] text-sage-deep block mb-3">/ nueva cuenta</span>
          <h1 className="font-heading text-4xl font-light text-forest mb-2">Crear cuenta</h1>
          <p className="text-stone text-sm mb-8">¿Ya tienes una? <Link to="/login" className="text-sage-deep hover:underline">Inicia sesión</Link></p>

          <button onClick={handleGoogle} data-testid="google-signup-btn" className="w-full flex items-center justify-center gap-3 border border-forest/15 bg-white py-3.5 hover:bg-mist transition mb-4 rounded-full">
            <GoogleLogo size={20} weight="bold" /> <span className="text-sm">Registrarse con Google</span>
          </button>

          <div className="flex items-center gap-3 my-6 text-[10px] uppercase tracking-[0.3em] text-ash">
            <div className="flex-1 h-px bg-forest/10" /> o con email <div className="flex-1 h-px bg-forest/10" />
          </div>

          <form onSubmit={submit} className="space-y-4">
            <label className="block">
              <span className="text-[10px] uppercase tracking-[0.2em] text-stone">Email</span>
              <input data-testid="register-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full bg-white border border-forest/15 px-4 py-3 text-sm focus:border-sage-deep focus:outline-none rounded-md" />
            </label>
            <label className="block">
              <span className="text-[10px] uppercase tracking-[0.2em] text-stone">Teléfono (opcional)</span>
              <input data-testid="register-phone" value={telefono} onChange={(e) => setTelefono(e.target.value)} className="mt-2 w-full bg-white border border-forest/15 px-4 py-3 text-sm focus:border-sage-deep focus:outline-none rounded-md" />
            </label>
            <label className="block">
              <span className="text-[10px] uppercase tracking-[0.2em] text-stone">Contraseña</span>
              <input data-testid="register-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full bg-white border border-forest/15 px-4 py-3 text-sm focus:border-sage-deep focus:outline-none rounded-md" />
            </label>
            <button type="submit" disabled={loading} data-testid="register-submit-btn" className="w-full bg-sage-deep text-paper py-3.5 font-medium tracking-wide text-sm hover:bg-forest transition flex items-center justify-center gap-2 disabled:opacity-50 rounded-full">
              {loading ? "Creando…" : <>Crear cuenta <ArrowRight size={16} /></>}
            </button>
          </form>
        </motion.div>
      </div>
      <div className="hidden lg:block relative overflow-hidden order-1 lg:order-2 bg-mist">
        <img src="https://images.pexels.com/photos/35248387/pexels-photo-35248387.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-l from-paper via-paper/30 to-transparent" />
        <div className="absolute bottom-12 right-12 max-w-md text-right">
          <h2 className="font-heading text-5xl font-light leading-tight text-forest">Únete y <span className="serif-italic font-medium text-sage-deep">empieza</span> ya.</h2>
        </div>
      </div>
    </div>
  );
};

export default Register;
